import { setEditableFieldValue, resetFieldsToInitialState, getEditableField } from '../../store';
import { buildCampaignConfigurationUrl } from '../../../utils/url-builders';
import { navigateToStep } from '../../utils/navigate-to-step';
import { EngageTracker } from '../../../tracking';
import { ENGAGE_CAMPAIGN_BUILDER_STEP_NAVIGATION } from '../../../tracking/events';
export var saveCampaignTypeSelection = function (payload) {
    var state = payload.store.getState();
    var existingType = getEditableField(state, 'type').value;
    // clean up the fields when users navigate back and change the campaign type
    var didCampaignTypeChange = !!existingType && existingType !== payload.newType;
    if (didCampaignTypeChange) {
        payload.store.dispatch(resetFieldsToInitialState({ session: payload.session }));
    }
    payload.store.dispatch(setEditableFieldValue({ name: 'type', value: payload.newType }));
    var nextStepPathname = buildCampaignConfigurationUrl({
        campaignId: payload.campaignId,
        session: payload.session,
    });
    // Track step navigation
    if (payload.campaignId) {
        EngageTracker.getInstance().track(ENGAGE_CAMPAIGN_BUILDER_STEP_NAVIGATION, {
            campaignId: payload.campaignId,
            fromStep: 'type',
            toStep: 'configuration',
            direction: 'forward',
        });
    }
    navigateToStep({
        store: payload.store,
        navigate: payload.navigate,
        stepPathname: nextStepPathname,
    });
};
